module.exports = __webpack_public_path__ + "img/pdf.df8691c4.svg";